import React, {Component} from 'react';
import PropTypes from "prop-types";
import ThumbTable from './tables/thumbTable';
import WriteModal from './modal/writeModal';

class Demo extends Component {
  constructor () {
    super();
    this.init();
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  init () {
  }

  render () {
    return <div>
      <ThumbTable></ThumbTable>
      <WriteModal />
    </div>;
  }
}

export default Demo;


// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo_1/demo.js